import { render, staticRenderFns } from "./collLogin.vue?vue&type=template&id=c6b108b2"
import script from "./collLogin.vue?vue&type=script&lang=js"
export * from "./collLogin.vue?vue&type=script&lang=js"
import style0 from "./collLogin.vue?vue&type=style&index=0&id=c6b108b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports